import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';

const StudentFilter = ({
  user,
  handleAddStudent,
  globalFilterValue,
  onGlobalFilterChange,
  selectedClass,
  classes,
  onClassFilterChange,
  selectedSection,
  sections,
  onSectionFilterChange,
  selectedStatus,
  statusOptions,
  onStatusFilterChange,
  showDetailsView,
  showFeeDetails
}) => {
  const getTitle = () => {
    if (showDetailsView) return "Student Details";
    if (showFeeDetails) return "Fee Details";
    return "Students Management";
  };

  const getSubtitle = () => {
    if (showDetailsView) return "View student profile and academic information";
    if (showFeeDetails) return "Manage and track student fee payments";
    return "Manage student records and information";
  };

  const getIcon = () => {
    if (showFeeDetails) return "pi pi-money-bill";
    return "pi pi-users";
  };

  return (
    <div className="mb-2 flex-shrink-0">
      <div className="bg-white/80 backdrop-blur-xl rounded-xl shadow-lg border border-white/20 p-4 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-400/10 to-indigo-500/10 rounded-full -translate-y-16 translate-x-16"></div>
        <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-purple-400/10 to-pink-400/10 rounded-full translate-y-12 -translate-x-12"></div>

        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className={`p-2 bg-gradient-to-br ${showFeeDetails ? 'from-green-500 to-emerald-600' : 'from-blue-500 to-blue-600'} rounded-lg shadow-lg`}>
              <i className={`${getIcon()} text-white text-sm`}></i>
            </div>
            <div>
              <h3 className="text-base font-bold text-gray-900">{getTitle()}</h3>
              <p className="text-xs text-gray-600 mt-0.5">{getSubtitle()}</p>
            </div>
          </div>

          {/* {!showDetailsView && !showFeeDetails && (user?.role === 'admin' || user?.role === 'teacher') && (
            <button onClick={handleAddStudent} className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-4 py-2 rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 flex items-center gap-2 font-semibold shadow-lg hover:shadow-xl text-sm">
              <i className="pi pi-plus text-sm"></i> Add Student
            </button>
          )} */}
        </div>

        {!showDetailsView && !showFeeDetails && (
          <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
            <div className="space-y-2">
              <label className="text-xs font-semibold text-gray-700 flex items-center"><i className="pi pi-search mr-1 text-blue-500 text-xs"></i>Search</label>
              <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Name, Admission..." className="w-full pl-3 pr-3 py-2 text-sm border border-gray-200 rounded-lg" />
            </div>

            <div className="space-y-2">
              <label className="text-xs font-semibold text-gray-700 flex items-center"><i className="pi pi-book mr-1 text-indigo-500 text-xs"></i>Class</label>
              <Dropdown value={selectedClass} options={classes.map(c => ({ label: c.name || c.className, value: c.id }))} onChange={onClassFilterChange} placeholder="All Classes" className="w-full text-sm border border-gray-200 rounded-lg" panelClassName="border border-gray-200 rounded-lg shadow-lg" showClear />
            </div>

            <div className="space-y-2">
              <label className="text-xs font-semibold text-gray-700 flex items-center"><i className="pi pi-th-large mr-1 text-purple-500 text-xs"></i>Section</label>
              <Dropdown value={selectedSection} options={sections.map(s => ({ label: s.name || s.section_name, value: s.id }))} onChange={onSectionFilterChange} placeholder="All Sections" disabled={!selectedClass} className="w-full text-sm border border-gray-200 rounded-lg" panelClassName="border border-gray-200 rounded-lg shadow-lg" showClear />
            </div>

            <div className="space-y-2">
              <label className="text-xs font-semibold text-gray-700 flex items-center"><i className="pi pi-flag mr-1 text-blue-500 text-xs"></i>Status</label>
              <Dropdown value={selectedStatus} options={statusOptions} onChange={onStatusFilterChange} placeholder="Select Status" className="w-full text-sm border border-gray-200 rounded-lg" panelClassName="border border-gray-200 rounded-lg shadow-lg" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StudentFilter;
